<template>
  <div class="material-wrapper">
    <div class="currentImg">
      <img :src="openMaterial[currentIndex].BannerSrc">
      <span class="img-index">{{`${currentIndex + 1}/${maxLen}`}}</span>
    </div>
    <div class="img-box">
      <div class="img-group">
        <div class="img-item" v-for="(item, index) in openMaterial" :key="index"
             :class="{'img-active': index === currentIndex}">
          <img :src="item.BannerSrc" @click="changeMainImg(item, index)">
        </div>
      </div>
    </div>
    <div class="footer">
      <p>图片尺寸：640px*300px</p>
      <p>格式：JPG，PNG，大小：150KB内。</p>
      <el-button type="primary" @click="showMaterialList">上传素材</el-button>
    </div>
    <!-- 素材管理 -->
    <el-dialog title="素材管理" :visible.sync="dialogTableVisible" class="material-govern" width="735px"
               :close-on-press-escape="false" :close-on-click-modal="false" :show-close="false">
      <span class="sl-custom-file">
        <input type="button" value="添加素材" class="btn-file"/>
        <input type="file" class="ui-input-file" ref="imgUpload" @change="uploadMaterialImg"/>
      </span>
      <p class="upload-tip">图片尺寸：640px*300px、格式：JPG，PNG、大小：150KB内、最多100张，开启数量最多5个</p>
      <ul class="material-list">
        <li class="material-item" v-for="(item, index) in copyMaterialsList" :key="index" :style="{height: listHeight}">
          <div class="left">
            <img :src="item.BannerSrc" alt="">
          </div>
          <div class="right">
            <div class="form-controller">
              <label class="label">素材名称</label>
              <el-input v-model="item.Name" placeholder="请输入素材名称（15字内）" maxlength="15"></el-input>
            </div>
            <div class="form-controller require">
              <label class="label">广告描述</label>
              <el-input v-model="item.Desc" placeholder="请输入广告描述（15字内）" maxlength="15"></el-input>
            </div>
            <div class="form-controller require">
              <label class="label">按钮名称</label>
              <el-input v-model="item.BtnName" placeholder="请输入按钮名称（15字内）" maxlength="15"></el-input>
            </div>
            <div class="form-controller require upload-vedio" v-if="showType ">
              <label class="label">视频地址</label>
              <el-input v-model="item.VideoMediaSrc" :title="item.VideoMediaSrc"
                        :style="{width: item.VideoBtn? '160px':'242px'}" placeholder="请点击按钮上传视频" readonly></el-input>
              <span class="upload-vedio-btn" v-if="item.VideoBtn">
                <el-button size="small" type="primary">上传视频</el-button>
                <input type="file" class="ui-input-file" :id="index" accept="video/mp4,video/ogg,video/webm"
                       @change="uploadMaterialVedio"/>
              </span>
            </div>
            <div class="form-controller">
              <label class="label">开启状态</label>
              <el-switch
                v-model="item.OpenState"
                active-color="#5798d7"
                inactive-color="#ccc">
              </el-switch>
            </div>
          </div>
        </li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeMaterialW(0)">取 消</el-button>
        <el-button type="primary" @click="closeMaterialW(1)">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {transferDate, toDou} from 'common/js/util'
  // api
  import {uploadMateriaImg} from 'api/strategy'

  // 素材最多开启个数
  const maxLen = 5

  export default {
    props: {
      materials: Array,
      showType: Number
    },
    data() {
      return {
        // 上传素材弹窗
        dialogTableVisible: false,
        currentImgId: 0,
        // 素材列表
        materialsList: [],
        // 复制素材列表
        copyMaterialsList: [],
        // 预览素材索引
        currentIndex: 0,
        // 最多开启素材长度
        listHeight: '190px',
        maxLen,
        copyList2: []
      }
    },
    computed: {
      // 获取开启素材 不够补位
      openMaterial() {
        // 获取当前开启素材
        let {openMaterials} = this.getOpenMaterial()
        // 数组补位
        for (let i = openMaterials.length; i < maxLen; i++) {
          openMaterials.push({
            BannerSrc: 'http://static.adjuz.com/backstage/img/upload_def_img.png'
          })
        }
        return openMaterials
      }
    },
    mounted() {
      if (this.showType) {
        this.listHeight = '225px'
      } else {
        this.listHeight = '190px'
      }
    },
    methods: {
      // 返回时间串
      exportTime(date) {
        let time = null
        if (typeof date === 'string') {
          time = parseInt(date.replace(/[-: ]/g, ''))
        } else {
          // 年
          let y = date.getFullYear();
          // 月
          let M = date.getMonth() + 1;
          // 日
          let d = date.getDate()
          // 时
          let h = date.getHours()
          // 分
          let m = date.getMinutes()
          // 秒
          let s = date.getSeconds()
          time = parseInt(`${y}${toDou(M)}${toDou(d)}${toDou(h)}${toDou(m)}${toDou(s)}`)
        }
        return time
      },
      // 获取开启或关闭素材
      getOpenMaterial() {
        // 开启素材
        let openMaterials = []
        // 关闭素材
        let closeMaterials = []
        // 筛选打开的素材
        for (let i = 0, materials = this.copyMaterialsList; i < materials.length; i++) {
          let item = materials[i]
          if (item.OpenState) {
            openMaterials.push(Object.assign({}, item))
          } else {
            closeMaterials.push(Object.assign({}, item))
          }
        }
        // 按添加时间排序素材
        openMaterials.sort((n, m) => {
          return this.exportTime(transferDate(n.AddDate)) - this.exportTime(transferDate(m.AddDate))
        })
        closeMaterials.sort((n, m) => {
          return this.exportTime(transferDate(n.AddDate)) - this.exportTime(transferDate(m.AddDate))
        })
        return {openMaterials, closeMaterials}
      },
      // 打开素材列表
      showMaterialList() {
        // 当前策略按开启关闭归类
        let {openMaterials, closeMaterials} = this.getOpenMaterial()
        // 同步按时间排序之后素材列表
        this.copyMaterialsList = openMaterials.concat(closeMaterials)
        // 打开素材弹窗
        this.dialogTableVisible = true
      },
      changeMainImg(item, index) {
        // 同步当前图片位置
        this.currentIndex = index
      },
      // 上传素材图片
      uploadMaterialImg(e) {
        let copyMaterialsList = this.copyMaterialsList
        if (copyMaterialsList.length > 100) {
          this.$message.error('素材最多上传100个～')
        }

        let file = e.target.files[0];
        if (file.size > 1000000) {
          this.$message.error('图片素材大小不能超过1M')
          return
        }
        if (file.type !== 'image/png' && file.type !== 'image/jpeg' && file.type !== 'image/gif') {
          this.$message.error('图片素材格式不正确')
          return
        }
        let param = new FormData()
        param.append('file', file, file.name)
        param.append('chunk', '0')
        let config = {
          headers: {'Content-Type': 'multipart/form-data'}
        }
        uploadMateriaImg(param, config).then(res => {
          if (res.status === 1) {
            let newImg = {
              AddDate: res.AddDate,
              BannerSrc: '',
              BtnName: "",
              Desc: "",
              MaterialId: 0,
              Name: "",
              OpenState: false,
              isNew: true,
              PutOnId: 0,

              VideoMediaSrc: '',
              VideoBtn: this.showType
            }
            // 在当前图片列表前插入
            this.copyMaterialsList.unshift(newImg)
            // 等待浏览器执行完插入之后修改图片地址，解决添加图片先显示第二张图片再显示第一张图片问题
            this.$nextTick(() => {
              this.copyMaterialsList[0].BannerSrc = res.imgurl;
              this.copyMaterialsList[0].WaterBannerSrc = res.waterImgUrl ? res.waterImgUrl : '';
              this.copyMaterialsList[0].YBWaterBannerSrc = res.ybWaterImgUrl ? res.ybWaterImgUrl : '';
            })
          } else {
            this.$message.error('图片上传失败，请重新上传！')
          }
          // 清空input选中值
          if (e.srcElement) {
            e.srcElement.value = ''
          } else {
            e.originalTarget.value = ''
          }
        })
      },

      //上传素材视频
      uploadMaterialVedio(e) {
        let index = e.srcElement ? Number(e.srcElement.id) : Number(e.target.id)
        let file = e.target.files[0];
        let param = new FormData()
        if (file.size / 1024 / 1024 > 100) {
          this.$message.error('视频大小不能超过100M')
          return;
        }
        param.append('file', file, file.name)
        param.append('chunk', '0')
        param.append('video', '1')
        let config = {
          headers: {'Content-Type': 'multipart/form-data'},
        }
        uploadMateriaImg(param, config).then(res => {
          if (res.status === 1) {
            this.$nextTick(() => {
              // 获取视频地址
              this.copyMaterialsList[index].VideoMediaSrc = res.imgurl
            })
          } else {
            this.$message.error('视频上传失败，请重新上传！')
          }
        })
      },
      // 关闭素材弹窗
      closeMaterialW(tag) {
        // 确定
        if (tag) {
          let {openMaterials, closeMaterials} = this.getOpenMaterial()

          let flag = 0;
          // 判断如果是视频素材是否上传视频
          if (this.showType) {
            this.copyMaterialsList.forEach(item => {
              if (!item.VideoMediaSrc) {
                flag++;
              }
            })
            if (flag > 0) {
              this.$message.error('请上传素材视频');
              return;
            }
          }
          if (openMaterials.length) {
            if (openMaterials.length > maxLen) {
              this.$message.error(`素材最多开启${maxLen}个～`)
              return
            }
            for (let i = 0; i < openMaterials.length; i++) {
              let item = openMaterials[i]
              if (item.Desc.trim() === '' || item.BtnName.trim() === '') {
                this.$message.error('已开启的素材，*号内容未填写完整~')
                return
              }
              this.copyMaterialsList.forEach(item => {
                item.VideoBtn = 0;
              })
              this.$emit('confirmMaterial', JSON.parse(JSON.stringify(this.copyMaterialsList)))
              this.$parent.$emit('confirmDisplayType', 1)
            }
          } else {
            this.$message.error('至少一张素材为开启开启状态～')
            return
          }
        } else {
          let materials = []
          for (let i = 0, materialsList = this.copyList2 ; i < materialsList.length; i++) {
            let item = materialsList[i]
            if (!item.isNew) {
              materials.push(item)
            }
          }
          this.copyMaterialsList = materials
        }
        // 关闭素材弹窗
        this.dialogTableVisible = false
      }
    },
    watch: {
      materials: {
        handler(val) {
          // 复制素材列表
          this.copyMaterialsList = val.map(item => item);
          this.copyList2 = JSON.parse(JSON.stringify(this.copyMaterialsList));
        }
      },
      showType(value) {
        if (value) {
          this.listHeight = '225px'
        } else {
          this.listHeight = '190px'
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '../../../common/scss/color.scss';

  .material-wrapper {
    width: 100%;
    height: 100%;
    border: 1px solid $borderColor;
    .currentImg {
      width: 100%;
      height: 260px;
      margin-bottom: 6px;
      position: relative;
      // 图片下标
      .img-index {
        position: absolute;
        right: 20px;
        bottom: 10px;
        font-size: 14px;
        color: #ccc;
      }
      img {
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        display: inline-block;
      }
    }
    .img-box {
      width: 100%;
      overflow-x: auto;
      .img-group {
        overflow: hidden;
        .img-item {
          float: left;
          width: 91px;
          height: 60px;
          margin: 4px;
          & + .img-item {
            margin-right: 10px;
          }
          &:last-child {
            margin-right: 0;
          }
          img {
            cursor: pointer;
            width: 100%;
            height: 100%;
          }
          &.img-active {
            position: relative;
            &:before {
              content: '';
              position: absolute;
              left: 0;
              top: 0;
              right: 0;
              bottom: 0;
              border: 1px solid #59b4fd;
            }
          }
        }
      }
    }
    .footer {
      position: relative;
      padding: 15px 10px;
      p {
        color: #999;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
      }
      .el-button {
        position: absolute;
        right: 10px;
        top: 10px;
      }
    }
  }

  .material-govern {
    .el-dialog__header {
      text-align: center;
      font-weight: 700;
      border-bottom: 1px solid $borderColor;
    }
    .el-dialog__body {
      padding-top: 0;
      margin-top: -30px;
      .sl-custom-file {
        position: relative;
        top: -14px;
        display: inline-block;
        zoom: 1;
        cursor: pointer;
        overflow: hidden;
        vertical-align: middle;
      }
      .btn-file {
        width: 100px;
        height: 34px;
        font-size: 16px;
        color: $mainColor;
        border-radius: 0;
        background-color: #fff;
      }
      .sl-custom-file .ui-input-file {
        position: absolute;
        right: 0;
        top: 0;
        _zoom: 30;
        font-size: 300px \9
      ;
        height: 100%;
        _height: auto;
        opacity: 0;
        filter: alpha(opacity=0);
        -ms-filter: "alpha(opacity=0)";
        cursor: pointer;
      }
    }
    .el-dialog {
      width: 57%;
    }

    .upload-tip {
      font-size: #aaa;
    }
    .material-list {
      min-height: 181px;
      max-height: 560px;
      // height: 560px;
      overflow-y: auto;
      .material-item {
        border: 1px solid $borderColor;
        border-radius: 4px;
        margin-top: 4px;
        width: 98%;
        height: 225px;
        display: flex;
        justify-content: space-between;
        .left {
          width: 47%;
          height: 100%;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .right {
          width: 51%;
          .form-controller {
            margin-top: 9px;
            margin-left: 10px;
            &.require::before {
              content: '*';
              color: red;
              margin-left: -8px;
              font-size: 18px;
              position: relative;
              top: 4px;
            }
          }
          .el-input {
            width: 243px;
            vertical-align: top;
          }
          .upload-vedio {
            .upload-vedio-btn {
              position: relative;
              overflow: hidden;
              width: 80px;
              display: inline-block;
              height: 35px;
              vertical-align: middle;
              margin-top: -3px;
              input {
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                z-index: 10;
                opacity: 0;
              }
            }
            .el-input {
              width: 160px;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/edit-plan-sub/multiMateial.vue